module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/fedex-00af80c21a58091c57830c485cc0e48b.svg";